import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../utils/color';

export default makeStyles((theme) => ({
  dialog_mask: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: Colors.EXTRA_GRAY,
    zIndex: 2,
  },
  dialog_container: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: 440,
    zIndex: 3,
    padding: 25,
    backgroundColor: theme.palette.dialog_background,
    overflow: 'auto',
  },
  form_details: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 25,
  },
  form_label: {
    color: theme.palette.form_label,
  },
  form_input: {
    '&::placeholder': {
      color: theme.palette.input_placeholder,
    },
    border: `1px solid ${theme.palette.input_border}`,
    backgroundColor: 'transparent',
    color: theme.palette.profile_title,
    '&:focus': {
      border: `1px solid ${theme.palette.input_border}`,
    },
  },
  form_input_container: {
    marginTop: 12,
  },
  phoneno_container: {
    display: 'flex',
  },
  countryCodeContainer: {
    marginRight: 5,
    minWidth: 100,
    maxWidth: 150,
  },
  phoneno_margin: {
    marginTop: 38,
  },
  add_button_container: {
    marginTop: 17,
  },
  add_button: {
    backgroundColor: theme.palette.background_button,
    color: theme.palette.background_button_text,
    '&:hover': {
      backgroundColor: theme.palette.background_button,
    },
  },
  flexView: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 25,
  },
}));
